import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { MessageBoxesContainer } from '../../components/messageBoxes/messageBoxesContainer';
import { useAppSelector } from '../../redux/store';
import { BuildTimestampChecker } from './buildTimestampChecker';
import { EntrySceneAlertContainer } from './entrySceneAlertContainer';
import { EntrySceneMainContent } from './entrySceneMainContent';
import { Footer } from './footer';
import { GameEntryDialog } from './gameEntryDialog';
import { WelcomePanel } from './welcomePanel';
const MAIN_CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  width: 100%;
`;
export const EntryScene = () => {
    const gameEntryDialogProperties = useAppSelector((state) => state.gameEntry.gameEntryDialogProperties);
    if (gameEntryDialogProperties) {
        return _jsx(GameEntryDialog, { gameEntryDialogProperties: gameEntryDialogProperties });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { id: 'top-scroll-target' }), _jsx(EntrySceneAlertContainer, {}), _jsxs("div", { css: MAIN_CONTAINER_CSS, children: [_jsx(EntrySceneMainContent, {}), _jsx(WelcomePanel, {})] }), _jsx(Footer, {}), _jsx(MessageBoxesContainer, {}), _jsx(BuildTimestampChecker, {})] }));
};
